export default __webpack_public_path__ + "static/media/Snd2.aedae7c0.mp3";